(function () {
  function formatWithCommas(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function moneyFormat(cents) {
    var formatted;
    if (window.Shopify && window.Shopify.formatMoney) {
      formatted = window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
      formatted = String(formatted).replace(/\$/g, '').trim();
      // Guard against formats that don't add thousands separators
      // (e.g. a plain "{{amount}}" format), so it always matches the
      // Liquid-rendered default price.
      if (cents >= 100000 && formatted.indexOf(',') === -1) {
        formatted = formatWithCommas(cents);
      }
    } else {
      formatted = formatWithCommas(cents);
    }
    return formatted;
  }

  function initCarousel(sectionEl) {
    var carousel = sectionEl.querySelector('[data-carousel]');
    if (!carousel) return null;

    var track = carousel.querySelector('[data-carousel-track]');
    // The nav pill (.ps-nav-float > .ps-carousel__nav) lives as a sibling
    // of .ps-media/.ps-info at the .ps-product__grid level, not nested
    // inside .ps-carousel, so prev/next buttons are looked up from the
    // whole section.
    var prevBtn = sectionEl.querySelector('[data-carousel-prev]');
    var nextBtn = sectionEl.querySelector('[data-carousel-next]');
    var dotsWrap = carousel.querySelector('[data-carousel-dots]');

    function visibleSlides() {
      return Array.prototype.filter.call(
        track.querySelectorAll('[data-carousel-slide]'),
        function (slide) { return !slide.hasAttribute('hidden'); }
      );
    }

    function buildDots() {
      var slides = visibleSlides();
      dotsWrap.innerHTML = '';
      if (slides.length <= 1) return;
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ps-carousel__dot';
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () {
          scrollToSlide(slides[i]);
          setTimeout(updateActiveDot, 400);
        });
        dotsWrap.appendChild(dot);
      });
      updateActiveDot();
    }

    // Scroll ONLY the carousel track sideways. scrollIntoView() can also
    // scroll the whole page / sticky containers, which made the arrows and
    // dots unreliable, so the track is scrolled directly instead.
    function scrollToSlide(slide) {
      if (!slide) return;
      var left = slide.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    function activeSlideIndex() {
      var slides = visibleSlides();
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function updateActiveDot() {
      var dots = dotsWrap.querySelectorAll('.ps-carousel__dot');
      var idx = activeSlideIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
      var count = visibleSlides().length;
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= count - 1;
    }

    function goTo(delta) {
      var slides = visibleSlides();
      var idx = activeSlideIndex();
      var next = Math.min(Math.max(idx + delta, 0), slides.length - 1);
      scrollToSlide(slides[next]);
      setTimeout(updateActiveDot, 400);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(1); });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 80);
    }, { passive: true });

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { goTo(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { goTo(-1); e.preventDefault(); }
    });

    // ---- Mobile touch swipe ----
    // Make sure the floating nav wrapper never swallows touches meant for
    // the images (only the arrow buttons stay tappable).
    var navFloat = sectionEl.querySelector('.ps-nav-float');
    if (navFloat) {
      navFloat.style.pointerEvents = 'none';
      navFloat.querySelectorAll('button').forEach(function (b) {
        b.style.pointerEvents = 'auto';
      });
    }
    // Allow horizontal gestures on the track while keeping vertical page scroll.
    track.style.touchAction = 'pan-y pinch-zoom';

    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartScroll = 0;
    var touchActive = false;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartScroll = track.scrollLeft;
      touchActive = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!touchActive) return;
      touchActive = false;

      // If native scrolling already moved the track, don't advance twice.
      if (Math.abs(track.scrollLeft - touchStartScroll) > 5) return;

      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

      goTo(dx < 0 ? 1 : -1);
    }, { passive: true });

    track.addEventListener('touchcancel', function () {
      touchActive = false;
    }, { passive: true });

    // Click-and-drag swipe for mouse/desktop (touch is handled above).
    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.pageX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.pageX - dragStartX;
      if (Math.abs(dx) > 4) dragMoved = true;
      track.scrollLeft = dragStartScrollLeft - dx;
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      // Snap to the nearest slide after a mouse drag
      var slides = visibleSlides();
      scrollToSlide(slides[activeSlideIndex()]);
      setTimeout(updateActiveDot, 400);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Prevent the drag from being interpreted as a click on the image underneath
    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    // Build the dots/arrows for the slides that are visible on load
    buildDots();

    return {
      showOnly: function (mediaIds) {
        var allSlides = track.querySelectorAll('[data-carousel-slide]');
        var anyMatched = false;
        allSlides.forEach(function (slide) {
          var id = slide.getAttribute('data-media-id');
          var match = mediaIds.length === 0 || mediaIds.indexOf(id) !== -1;
          if (match) anyMatched = true;
          slide.hidden = !match;
        });
        if (!anyMatched) {
          allSlides.forEach(function (slide) { slide.hidden = false; });
        }
        track.scrollTo({ left: 0, behavior: 'auto' });
        buildDots();
      },
      refresh: buildDots,
    };
  }

  // -------------------------------------------------------------------
  // NOTE: cart submission is intentionally NOT handled here.
  // <product-form-component> (theme-native, assets/product-form.js)
  // owns the /cart/add POST, the CartAddEvent dispatch, and telling
  // <cart-drawer-component> to open. This file only handles visual
  // enhancements: color/size selection, live price/media swap, and the
  // carousel. As long as the hidden variant-id input's value is kept in
  // sync with the selected variant (see updateUI below), the native
  // component reads it correctly on submit.
  //
  // DATA SOURCE: variant data (price, stock, SKU, images) is read from the
  // <script type="application/json" data-ps-product-data> block rendered by
  // Liquid. That block has real inventory counts and needs no network
  // request. If it is missing, the product .js endpoint is used as a
  // fallback (which has NO inventory counts).
  //
  // Option-button selection is wired up SYNCHRONOUSLY below and the
  // selected options are read from the DOM, so selecting never waits on
  // any data.
  // -------------------------------------------------------------------
  function initSection(sectionEl) {
    var form = sectionEl.querySelector('.ps-form');
    var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = sectionEl.querySelector('[id^="ps-price-"]');
    var atcBtn = sectionEl.querySelector('[id^="ps-atc-"]');
    var atcText = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    var stockEl = sectionEl.querySelector('[id^="ps-stock-"]');
    var skuEl = sectionEl.querySelector('[data-meta="sku"]');

    var carouselApi = null;
    try {
      carouselApi = initCarousel(sectionEl);
    } catch (err) {
      console.warn('[ps-product] carousel failed to start:', err);
    }

    // Accordion (legacy button-based triggers; the Liquid now uses native
    // <details>/<summary>, so this is a harmless no-op in that case)
    sectionEl.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });

    var product = null;
    var selectedOptions = [];

    // Start from whatever is already selected on screen
    sectionEl.querySelectorAll('.ps-option').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var sel = group.querySelector('.is-selected');
      if (!isNaN(idx) && sel) selectedOptions[idx] = sel.getAttribute('data-value');
    });

    function findVariant() {
      if (!product) return null;
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return selectedOptions[i] === undefined || opt === selectedOptions[i];
        });
      });
    }

    function mediaIdsForVariant(variant) {
      if (!variant) return [];
      var ids = [];
      if (variant.featured_media && variant.featured_media.id) {
        ids.push(String(variant.featured_media.id));
      }
      (product.media || []).forEach(function (media) {
        if (media.alt && variant.title && media.alt === variant.title) {
          ids.push(String(media.id));
        }
      });
      return ids;
    }

    function updateUI(variant) {
      if (!variant) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      // Keep the hidden variant-id input in sync: the native
      // product-form-component reads it via `new FormData(form)` at
      // submit time.
      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = moneyFormat(variant.price);

      if (atcBtn) atcBtn.disabled = !variant.available;
      if (atcText) {
        atcText.textContent = variant.available
          ? 'Add to cart — ' + moneyFormat(variant.price)
          : 'Sold out';
      }

      if (skuEl && variant.sku) skuEl.textContent = 'SKU: ' + variant.sku;

      if (stockEl) {
        var threshold = parseInt(stockEl.getAttribute('data-threshold'), 10) || 10;
        var qty = variant.inventory_quantity;
        var html = '';
        if (!variant.inventory_management) {
          html = '<span class="ps-stock__dot"></span> In stock';
        } else if (typeof qty !== 'number') {
          // No inventory number available: fall back to availability only
          html = variant.available
            ? '<span class="ps-stock__dot"></span> In stock'
            : '<span class="ps-stock__dot ps-stock__dot--out"></span> Out of stock';
        } else if (qty > threshold) {
          html = '<span class="ps-stock__dot"></span> There are ' + qty + ' products left';
        } else if (qty > 0) {
          html = '<span class="ps-stock__dot ps-stock__dot--low"></span> Only ' + qty + ' left in stock';
        } else if (variant.inventory_policy === 'continue' && variant.available) {
          html = '<span class="ps-stock__dot"></span> In stock';
        } else {
          html = '<span class="ps-stock__dot ps-stock__dot--out"></span> Out of stock';
        }
        stockEl.innerHTML = html;
      }

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        } catch (err) {}
      }

      if (carouselApi) carouselApi.showOnly(mediaIdsForVariant(variant));
    }

    // Wires up one group of option buttons (swatches, sizes, or generic
    // options). The visual is-selected toggle always runs; the
    // variant/price/stock/media sync runs as soon as product data exists.
    function bindOptionGroup(selector, onSelect) {
      sectionEl.querySelectorAll(selector).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;

          var optionIndex = parseInt(btn.getAttribute('data-option-index'), 10);
          var value = btn.getAttribute('data-value');
          selectedOptions[optionIndex] = value;

          sectionEl
            .querySelectorAll(selector + '[data-option-index="' + optionIndex + '"]')
            .forEach(function (s) { s.classList.remove('is-selected'); });
          btn.classList.add('is-selected');

          if (onSelect) onSelect(value);

          if (product) {
            try {
              updateUI(findVariant());
            } catch (err) {
              console.warn('[ps-product] could not update variant UI:', err);
            }
          }
        });
      });
    }

    bindOptionGroup('.ps-swatch', function (value) {
      var labelEl = sectionEl.querySelector('[data-color-label]');
      if (labelEl) labelEl.textContent = value;
    });
    bindOptionGroup('.ps-size');
    bindOptionGroup('.ps-generic-option');

    function adoptProduct(data) {
      product = data;
      if (carouselApi) carouselApi.refresh();
    }

    // 1) Preferred: data rendered by Liquid (real stock, no network needed)
    var dataEl = sectionEl.querySelector('script[data-ps-product-data]');
    if (dataEl) {
      try {
        adoptProduct(JSON.parse(dataEl.textContent));
        return;
      } catch (err) {
        console.warn('[ps-product] could not read embedded product data, falling back to .js:', err);
      }
    }

    // 2) Fallback: product .js endpoint (no inventory counts)
    var productUrl = sectionEl.getAttribute('data-product-url');
    if (!productUrl) return;

    fetch(productUrl)
      .then(function (res) { return res.json(); })
      .then(adoptProduct)
      .catch(function (err) {
        console.warn('[ps-product] enhancement data failed to load — option buttons still work, but live price/stock/media sync is unavailable:', err);
      });
  }

  document.querySelectorAll('[data-section-type="main-product-seventh"]').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="main-product-seventh"]');
    if (el) initSection(el);
  });
})();